/* eslint-disable no-use-before-define */
/* eslint-disable react/prop-types */
import React, { useEffect } from "react";
import { useLocation, matchPath } from "react-router";
import PropTypes from "prop-types";
import {
  Avatar,
  Box,
  Divider,
  Drawer,
  Hidden,
  List,
  ListSubheader,
  Typography,
  makeStyles,
} from "@material-ui/core";
import NavItem from "./NavItem";
import navConfigAdminSistema from "src/data/navConfigAdminSistema";
import navConfigDueno from "src/data/navConfigDueno";
import navConfigVendedor from "src/data/navConfigVendedor";
import navConfigAdmin from "src/data/navConfigAdmin";
import navConfigOperario from "src/data/navConfigOperario";

const navItemXPerfil = {
  Vendedor: navConfigVendedor,
  Dueño: navConfigDueno,
  Administrador: navConfigAdmin,
  "Administrador de sistema": navConfigAdminSistema,
  Operario: navConfigOperario,
};

function renderNavItems({ items, ...rest }) {
  return (
    <List disablePadding>
      {items.reduce(
        (acc, item) => reduceChildRoutes({ acc, item, ...rest }),
        []
      )}
    </List>
  );
}

function reduceChildRoutes({ acc, pathname, item, depth = 0 }) {
  const key = item.title + depth;

  if (item.items) {
    const open = matchPath(pathname, {
      path: item.href,
      exact: false,
    });

    acc.push(
      <NavItem
        depth={depth}
        icon={item.icon}
        key={key}
        info={item.info}
        open={Boolean(open)}
        title={item.title}
      >
        {renderNavItems({
          depth: depth + 1,
          pathname,
          items: item.items,
        })}
      </NavItem>
    );
  } else {
    acc.push(
      <NavItem
        depth={depth}
        href={item.href}
        icon={item.icon}
        key={key}
        info={item.info}
        title={item.title}
      />
    );
  }

  return acc;
}

const useStyles = makeStyles((theme) => ({
  mobileDrawer: {
    width: 256,
  },
  desktopDrawer: {
    width: 256,
    top: 64,

    height: "calc(100% - 64px)",
  },
  avatar: {
    // cursor: "pointer",
    width: 64,
    height: 64,
  },
}));

function NavBar({ openMobile, onMobileClose }) {
  const classes = useStyles();
  const location = useLocation();
  const { username, perfil } = JSON.parse(
    localStorage.getItem("user_settings")
  );

  let navConfig = navItemXPerfil[perfil];

  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose();
    }
    // eslint-disable-next-line
  }, [location.pathname]);

  const content = (
    <Box height="100%" display="flex" flexDirection="column">
      <Box p={2}>
        <Box display="flex" justifyContent="center">
          <Avatar alt="User" className={classes.avatar} />
        </Box>
        <Box mt={2} textAlign="center">
          <Typography variant="h5" color="textPrimary" underline="none">
            {username}
          </Typography>
          <Typography variant="body2" color="textPrimary" underline="none">
            {perfil}
          </Typography>
        </Box>
      </Box>
      <Divider />
      <Box p={2}>
        {navConfig().map(({ subheader, info: Info, items }) => (
          <List
            key={subheader}
            subheader={
              <ListSubheader
                disableGutters
                disableSticky
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                {subheader}
                {Info && <Info className={classes.info} />}
              </ListSubheader>
            }
          >
            {renderNavItems({
              items: items,
              pathname: location.pathname,
            })}
          </List>
        ))}
      </Box>
      <Divider />
    </Box>
  );

  return (
    <>
      <Hidden lgUp>
        <Drawer
          anchor="left"
          classes={{ paper: classes.mobileDrawer }}
          onClose={onMobileClose}
          open={openMobile}
          variant="temporary"
        >
          {content}
        </Drawer>
      </Hidden>
      <Hidden mdDown>
        <Drawer
          anchor="left"
          classes={{ paper: classes.desktopDrawer }}
          open
          variant="persistent"
        >
          {content}
        </Drawer>
      </Hidden>
    </>
  );
}

NavBar.propTypes = {
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool,
};

export default NavBar;
